const prodConfig = require("./config.prod.json");
const stagConfig = require("./config.stag.json");
const defaultConfig = require("./config.json");

interface IConfig {
  SERVER_URL: string;
  BUCKET_URL: string;
  AUTH_URL: string;
  USER_INFO_URL: string;
  BACKUP_BUCKET: string;
  STRIPE_PUBLIC_KEY: string;
  CAPTCHA_PUBLIC_KEY: string;
}

let actualConfig = defaultConfig;

if (process.env.NEXT_PUBLIC_ENVIRONMENT === "PROD") {
  actualConfig = prodConfig;
} else if (process.env.NEXT_PUBLIC_ENVIRONMENT === "STAG") {
  actualConfig = stagConfig;
}

export default actualConfig as IConfig;

export const SERVER_URL: string = actualConfig.SERVER_URL;
export const BUCKET_URL: string = actualConfig.BUCKET_URL;
export const AUTH_URL: string = actualConfig.AUTH_URL;
export const USER_INFO_URL: string = actualConfig.USER_INFO_URL;
export const BACKUP_BUCKET: string = actualConfig.BACKUP_BUCKET;
export const STRIPE_PUBLIC_KEY: string = actualConfig.STRIPE_PUBLIC_KEY;
export const CAPTCHA_PUBLIC_KEY: string = actualConfig.CAPTCHA_PUBLIC_KEY;
